import { BaseModel } from './base'
import { SebraeEmpresa } from '@/models/sebraeEmpresa'

export class SebraeCarro extends BaseModel {
  constructor(
    public id: number,
    public placa: string,
    public modelo: string,
    public cor: string,
    public anoFabricacaoModelo: string,
    public proprietario: string,
    public createdAt: string,    
    public sebraeEmpresa: SebraeEmpresa
  ) {
    super(id)
  }
}